// eslint-disable-next-line import/no-unresolved, import/extensions
import Success from './SuccessVOI';

export default Success;
